export default __webpack_public_path__ + "static/media/3.c3ff8f48.jpg";